
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

import {
  Swiper,
  SwiperSlide
} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "OurWellCoordinatedTeamBlock",

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 8,
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        breakpoints: {
          640: {
            slidesPerView: 2,
            slidesPerGroup: 1,
          },
          860: {
            slidesPerView: 3,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
          1200: {
            spaceBetween: 20,
            slidesPerView: 5,
            slidesPerGroup: 1,
          },
        },
        pagination: {
          el: ".our-well-coordinated-team__slider-pagination-dots-list",
          type: 'bullets',
          dynamicBullets: true
        },
        navigation: {
          prevEl: '.our-well-coordinated-team__button-navition--prev',
          nextEl: '.our-well-coordinated-team__button-navition--next'
        },
      },
      activeSlide: 0
    }
  },

  computed: {
    sectionTitle: function () {
      return this.values?.title || ''
    },
    sectionItems: function () {
      return this.values?.items || []
    },
  },

  components: {
    Swiper,
    SwiperSlide,
  },

  methods: {
    slideChange: function () {
      const activeIndex = this.$refs?.refSwiper?.$swiper?.activeIndex;
    }
  }
});
